import { render, staticRenderFns } from "./Sections.vue?vue&type=template&id=26d4ffc5&"
import script from "./Sections.vue?vue&type=script&lang=ts&"
export * from "./Sections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports